exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input-0a6c9{width:100%}.transfer-f43a8{justify-content:space-between}.transferList-7382e{width:45%}", ""]);

// Exports
exports.locals = {
	"input": "input-0a6c9",
	"transfer": "transfer-f43a8",
	"transferList": "transferList-7382e"
};